import { render } from "./QuickAccessPopup.vue?vue&type=template&id=f31326ae&scoped=true"
import script from "./QuickAccessPopup.vue?vue&type=script&lang=js"
export * from "./QuickAccessPopup.vue?vue&type=script&lang=js"

import "./QuickAccessPopup.vue?vue&type=style&index=0&id=f31326ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f31326ae"]])

export default __exports__